import { useMemo } from "react"

import { useModalCustomOptions } from "#/shared/hooks"
import { MezoModalProps, VaultTokens } from "#/shared/types"
import { StepperModal } from "#/ui/Modal/StepperModal"

import SuccessfullyDepositedIntoVault from "./SuccessfullyDepositedIntoVault"
import VaultDepositStep from "./VaultDepositStep"
import VaultReviewStep from "./VaultReviewStep"

export default function DepositIntoVaultModal(props: MezoModalProps) {
  const { token } = useModalCustomOptions<{ token: VaultTokens }>()

  const context = useMemo(
    () => ({ token: token ?? "MUSD", amount: undefined }),
    [token],
  )

  return (
    <StepperModal
      {...props}
      initialContextValue={context}
      steps={[
        {
          title: "Vault Deposit",
          withCloseButton: true,
          component: VaultDepositStep,
        },
        {
          title: "Review",
          withCloseButton: true,
          component: VaultReviewStep,
        },
        {
          title: "Success ",
          component: SuccessfullyDepositedIntoVault,
          withCloseButton: true,
          withBackButton: false,
        },
      ]}
      overrides={{
        Dialog: {
          style: () => ({
            justifyContent: "start",
          }),
        },
      }}
    />
  )
}
